# If you're coming from the future - be aware! 
# YOUTUBE will not play videos with this API if you're serving the iframe from localhost or IP adress
# To workaround and test it locally, you can edit you /private/etc/hosts to create a local DNS

window.onYouTubePlayerAPIReady = -> Backbone.trigger("youtubeplayerapiready")
tag      = document.createElement("script")
protocol = window.location.protocol.replace("file", "http")
if __?.slidedeck?.platform is "iOS"
  protocol = window.location.protocol.replace("ionic", "http")
tag.src  = "#{protocol}//www.youtube.com/player_api"
document.head.appendChild(tag, "beforeEnd")
